// third-party
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoggedIn: false,
    isLoadingProduct: true,
    isProfile: false,
    isInitialized: false,
    dataProductDetails: [],
    dataProductImages: [],
    user: null,
    billings: [],
    queries: [],
    status: 'idle',
    conversationId: null
};

export const slice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        //LOGIN
        loginUser(state, action) {
            const { user } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                isProfile: user?.['is_profile'] || false,
                isInitialized: true,
                user
            };
        },

        //LOGOUT
        logoutUser(state, action) {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                isProfile: false,
                user: null
            };
        },

        //SET_INITIALIZED
        setInitialized(state, action) {
            return {
                ...state,
                isInitialized: true
            };
        },

        //REGISTER
        registerUser(state, action) {
            const { user } = action.payload;
            return {
                ...state,
                user
            };
        },

        //LOADING
        setLoading(state, action) {
            state.isLoading = action.payload;
        }
    }
});

export default slice.reducer;
export const { loginUser, logoutUser, registerUser, setLoading, setInitialized } = slice.actions;
